<template>
  <transition name="alert">
    <div 
      v-if="show"
      class="fixed top-4 right-4 z-50 p-4 rounded-lg shadow-lg flex items-center"
      :class="alertClasses"
    >
      <i :class="iconClass" class="mr-2"></i>
      {{ message }}
    </div>
  </transition>
</template>

<script setup>
import { computed, ref, watch } from 'vue'

const props = defineProps({
  type: {
    type: String,
    default: 'success', // success | error | info | warning
  },
  message: String,
  duration: {
    type: Number,
    default: 3000
  }
})

const show = ref(false)
const alertClasses = computed(() => {
  return {
    'success': 'bg-green-100 text-green-800',
    'error': 'bg-red-100 text-red-800',
    'info': 'bg-blue-100 text-blue-800',
    'warning': 'bg-yellow-100 text-yellow-800'
  }[props.type]
})

const iconClass = computed(() => {
  return {
    'success': 'fas fa-check-circle',
    'error': 'fas fa-exclamation-circle',
    'info': 'fas fa-info-circle',
    'warning': 'fas fa-exclamation-triangle'
  }[props.type]
})

watch(() => props.message, (newVal) => {
  if (newVal) {
    show.value = true
    setTimeout(() => {
      show.value = false
    }, props.duration)
  }
})
</script>

<style>
.alert-enter-active,
.alert-leave-active {
  transition: all 0.3s ease;
}

.alert-enter-from,
.alert-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
</style> 